import { Callout } from "@blueprintjs/core";
import React from "react";

export const SuccessCard = (p: { text: string; display: boolean }) =>
  p.display ? (
    <Callout intent="success" style={{ marginBottom: 20 }}>
      {p.text}
    </Callout>
  ) : (
    <></>
  );
